<template>
  <span id="update-all-bill-to-section" v-if="shouldBeDisplayed()">
    <el-button v-if="!isDropDownItem" id="btn-update-all-bill-to" type="success" plain @click="toggleDialogVisible()" size="mini">
      {{ $t('customerService.shipment.updateAllBillTo') }}
    </el-button>
    <el-dropdown-item v-if="isDropDownItem" id="close-billing-dropdown-item" @click.native="toggleDialogVisible()">
      <span class="more-actions-option">{{ $t('customerService.shipment.updateAllBillTo') }}</span>
    </el-dropdown-item>
    <el-dialog
      :close-on-click-modal="false"
      v-on:open="handleOpen"
      :title="$t('customerService.shipment.updateAllBillTo')"
      :visible.sync="dialogVisible"
      width="50%"
      class="dialog-with-cols"
      id="close-billing-dialog"
      append-to-body
    >
      <el-form
        :model="editForm"
        :rules="editFormRules"
        ref="editForm"
        label-position="top"
        size="mini"
      >
        <el-row :gutter="20">
          <el-col :md="12" :span="24">
            <el-form-item :label="$t('customerService.shipment.paymentTerms')" prop="paymentTerm">
              <el-select v-model="editForm.paymentTerm">
                <el-option
                  v-for="option in shipmentPaymentTerms"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :md="12" :span="24">
            <el-form-item
              :label="$t('customerService.shipment.billTo')"
              prop="billToAccountId"
              v-show="editForm.paymentTerm === thirdParty"
            >
              <autocomplete
                :model.sync="editForm.billToAccountId"
                :url="urlBillTo"
                labelField="name"
                labelFieldLastWithDash="number"
                valueField="id"
                ref="billToAccount"
              ></autocomplete>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
        <el-button type="primary" id="form-run-rating-button" @click="submitForm()" size="mini">{{ $t('customerService.shipment.updateAllBillTo') }}</el-button>
        <el-button id="form-clear-button" @click="resetForm()" size="mini">{{ $t('common.clear') }}</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import Autocomplete from '@/components/Autocomplete';

export default {
  name: 'UpdateAllBillTo',
  components: { Autocomplete },
  props: {
    isDropDownItem: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['shipment']),
    shipmentPaymentTerms() {
      return constants.SHIPMENT.PAYMENT_TERMS;
    },
    urlBillTo() {
      return apiConstants.END_POINTS.ACCOUNTS.BILL_TO;
    },
    thirdParty() {
      return constants.SHIPMENT.PAYMENT_TERMS[2].value;
    },
    existValidShipments() {
      return this.shipment.list.some((value) => {
        const statusName = constants.SHIPMENT.STATUS[value.status].label;
        return statusName === 'Open' || statusName === 'Rated' || statusName === 'Master' || statusName === 'Error';
      });
    },
  },
  data() {
    const validateBillToAccountId = (rule, value, callback) => {
      if (this.editForm.paymentTerm && this.editForm.paymentTerm === this.thirdParty && !value) {
        callback(new Error(this.$t('customerService.shipment.error.billToAccountIdRequired')));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      shipmentsToUpdate: 0,
      editForm: {
        paymentTerm: null,
        billToAccountId: null,
      },
      editFormRules: {
        paymentTerm: [
          {
            required: true,
            message: this.$t('customerService.shipment.error.paymentTermRequired'),
            trigger: 'blur'
          }
        ],
        billToAccountId: [
          {
            required: true,
            validator: validateBillToAccountId,
            trigger: 'submit'
          }
        ]
      },
    };
  },
  mounted() {
    if (this.shouldBeDisplayed() && this.isDropDownItem) {
      this.$emit('displayDropdown');
    }
  },
  methods: {
    shouldBeDisplayed() {
      return this.$can(this.permissions.BILLING.UPDATE_ALL_BILL_TO) && this.existValidShipments;
    },
    toggleDialogVisible() {
      const loading = this.$loading(constants.LOADING.UPDATE_ALL_SHIPMENT_BILL_TO_VALIDATION_CONFIG);
      this.$store.dispatch('shipment/updateBillToValidation')
        .then((response) => {
          if (response && response.data) {
            this.shipmentsToUpdate = response.data;
          }
          this.dialogVisible = true;
        })
        .catch(error => this.$message.error(error.response.message))
        .finally(() => loading.close());
    },
    handleOpen() {
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    resetForm() {
      this.$refs.editForm.resetFields();
      this.editForm.paymentTerm = null;
      this.editForm.billToAccountId = null;
      this.$nextTick(() => {
        this.$refs.billToAccount.clearLocalModel();
      });
    },
    submitForm() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          const confirmMessage = this.$t('customerService.shipment.updateAllBillToConfirmation')
            .replace('[shipmentsToUpdate]', this.shipmentsToUpdate);
          const confirm = await this.$confirm(confirmMessage, { confirmButtonText: this.$t('common.updateAll') })
            .catch(() => {});

          if (confirm) {
            Message.closeAll();
            const loading = this.$loading(constants.LOADING.UPDATE_ALL_SHIPMENT_BILL_TO_CONFIG);
            this.$store
              .dispatch('shipment/updateBillTo', this.editForm)
              .then((response) => {
                this.$store.dispatch('shipment/search', {});
                this.dialogVisible = false;
                if (response.data) {
                  this.$message.warning(response.message);
                } else {
                  this.$message.success(response.message);
                }
              })
              .finally(() => {
                loading.close();
              });
          }
        }
      });
    },
  }
};
</script>
